import { http } from 'services/http';
import { CARGO_ITEMS_MANY, CARGO_TRIPS_MANY, TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys.ts';
import type { CargoTripRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IDeleteCargoTripVariables {
  tripId: number;
  cargoId: number;
  cargoTripId: number;
  cargoItemId?: number;
}

export const useDeleteCargoTrip = () => {
  return useMutationBase<CargoTripRes, unknown, IDeleteCargoTripVariables>({
    mutationFn: async (variables) => {
      const { tripId, cargoTripId, cargoItemId } = variables;
      const res = await http.delete<CargoTripRes>(`/v1/trips/${tripId}/cargo-trips/${cargoTripId}`, {
        data: { cargoItemId },
      });

      return res.data;
    },

    invalidateCallback: (_, { tripId, cargoId }) => [
      [TRIP_GET_ONE, tripId],
      [CARGO_TRIPS_MANY, tripId],
      [CARGO_ITEMS_MANY, cargoId],
      [TRIP_TASKS_GET_MANY, tripId],
    ],
  });
};
